import cesCstDetailsLocale from './en.json'

const en = {
  cesCstDetails: cesCstDetailsLocale,
}

export default en
